<template>
    <div :loading="allLoading">
        <el-descriptions class="margin-top" title="赛事信息" :column="1" size="default">

        </el-descriptions>
        <el-form label-width="180px" style="width: 800px;" :model="MatchEditForm" :rules="MatchEditFormRules"
            ref="MatchEditFormRef">
            <el-form-item label="赛事名称" prop="MatchName">
                <el-input size="small" v-model="MatchEditForm.MatchName" placeholder="赛事名称" />
            </el-form-item>
            <el-form-item label="赛事简称" prop="MatchSimpleName">
                <el-input size="small" v-model="MatchEditForm.MatchSimpleName" placeholder="赛事简称" />
            </el-form-item>
            <el-form-item label="报名时间" prop="MatchSignUpTimes">
                <el-date-picker size="small" v-model="MatchEditForm.MatchSignUpTimes" type="datetimerange"
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']" />
            </el-form-item>
            <el-form-item label="比赛时间" prop="MatchTime">
                <el-date-picker size="small" v-model="MatchEditForm.MatchTime" type="datetimerange" range-separator="至"
                    start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" />
            </el-form-item>
            <!-- <el-form-item label="开始时间">
          <el-date-picker v-model="MatchEditForm.StartTime" type="datetime" placeholder="选择日期时间" />
        </el-form-item>

        <el-form-item label="结束时间">
          <el-date-picker v-model="MatchEditForm.EndTime" type="datetime" placeholder="选择日期时间" />
        </el-form-item> -->
            <el-form-item label="举办地点" prop="MatchAddress">
                <el-input size="small" v-model="MatchEditForm.MatchAddress" placeholder="举办地点" />
            </el-form-item>

            <el-form-item label="限报队数" prop="LimitSignUpTeamNum">
                <el-input-number size="small" v-model="MatchEditForm.LimitSignUpTeamNum" :min="0"
                    :max="100"></el-input-number>
                <span style="color: red;padding-left: 10px;">填0则不限制,单人项目1人视为1队</span>
            </el-form-item>
            <el-form-item label="限报项目数" prop="LimitSignUpProjectNum">
                <el-input-number size="small" v-model="MatchEditForm.LimitSignUpProjectNum" :min="0"
                    :max="100"></el-input-number>
                <span style="color: red;padding-left: 10px;">填0则不限制</span>
            </el-form-item>
            <el-form-item label="每人限报队伍数" prop="EveryBodyComposeTeamMaxNum">
                <el-input-number size="small" v-model="MatchEditForm.EveryBodyComposeTeamMaxNum" :min="0"
                    :max="100"></el-input-number>
                <span style="color: red;padding-left: 10px;">每个分组人员为一个队伍，填0则不限制</span>
            </el-form-item>

            <el-form-item label="自动审批">
                <el-radio-group v-model="MatchEditForm.AutoAudit">
                    <el-radio :label="0">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                </el-radio-group>
                <div style="color: red;padding-left: 10px;">系统自动审批仅能判断简单的规则(如参与人数、性别)，<br /> 如需验证年龄/单人参与等，请使用人工审核</div>

            </el-form-item>

            <el-form-item label="赛事介绍">
                <el-input type="textarea" size="small" v-model="MatchEditForm.MatchIntroduction" placeholder="赛事介绍" />
            </el-form-item>

            <el-form-item label="赛事相关附件">
                <el-button size="small" @click="file_list = []; uploadDialogVisible = true">上传文件</el-button>
                <div v-for="(file, index) in MatchEditForm.Files">
                    <div class="file-item">
                        <div class="file-name" style="width: 450px;">
                            {{ file.FileName + file.FileSuffix }}
                        </div>
                        <div class="del" style="text-align: right;">
                            <i class="icon  el-icon-close" @click="MatchEditForm.Files.splice(index, 1)"></i>
                        </div>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="评分大屏背景图">
                <div v-if="MatchEditForm.ScoreLargeScreenBackGroundImageFilePath != ''"
                    style="position: relative; width: 120px;">
                    <img :src="fileRootPath + MatchEditForm.ScoreLargeScreenBackGroundImageFilePath">
                    <div style="position: absolute;top: -15px; right: -10px;color: red;font-size: 20px;"
                        @click.stop="handleRemoveBackGroundImage('score')">
                        <el-button icon="el-icon-delete" size="small" style="font-size:15px;color: red;opacity: 0.8;"
                            circle></el-button>
                        <!-- <i class="el-icon-delete"></i> -->
                    </div>
                </div>

                <el-upload v-else class="logo-uploader" action=""
                    :http-request="(file) => customRequestBgImage(file, 'score')" :show-file-list="false"
                    accept=".jpg,.png,.jpeg">
                    <!-- <i class="el-icon-plus logo-uploader-icon"></i> -->
                    <el-button size="small">上传图片</el-button>
                </el-upload>

            </el-form-item>
            <el-form-item label="排行大屏背景图">
                <div v-if="MatchEditForm.RankLargeScreenBackGroundImageFilePath != ''"
                    style="position: relative; width: 120px;">
                    <img :src="fileRootPath + MatchEditForm.RankLargeScreenBackGroundImageFilePath">
                    <div style="position: absolute;top: -15px; right: -10px;color: red;font-size: 20px;"
                        @click.stop="handleRemoveBackGroundImage('rank')">
                        <el-button icon="el-icon-delete" size="small" style="font-size:15px;color: red;opacity: 0.8;"
                            circle></el-button>
                        <!-- <i class="el-icon-delete"></i> -->
                    </div>
                </div>

                <el-upload v-else class="logo-uploader" action=""
                    :http-request="(file) => customRequestBgImage(file, 'rank')" :show-file-list="false"
                    accept=".jpg,.png,.jpeg">
                    <!-- <i class="el-icon-plus logo-uploader-icon"></i> -->
                    <el-button size="small">上传图片</el-button>
                </el-upload>
            </el-form-item>
            <div style="height: 30px;margin-bottom: 30px;text-align: right;">
                <el-button type="primary" size="small" @click="submitMatchEdit">保存</el-button>

            </div>
        </el-form>

        <el-descriptions class="margin-top" title="分组及项目" :column="1" :size="size" v-if="MatchEditForm.MatchId != ''"">

        </el-descriptions>
        <el-row v-if="MatchEditForm.MatchId != '' && !MatchGroupEditFormVisible">
            <div style="display: flex;">
                <div v-if="MatchGroupEditForm.MatchGroups != null && MatchGroupEditForm.MatchGroups.length > 0">
                    <!-- <el-tag v-for=" (r, index) in MatchGroupEditForm.MatchGroups"
                        :effect="groupActiveIndex == index ? 'dark' : 'plain'"
                        :type="groupActiveIndex == index ? 'success' : 'info'" :key="r.GroupId"
                        @click="clickGroupItem(index)">
                        {{ r.GroupName }}
                    </el-tag> -->

                    <el-button v-for="(r, index) in MatchGroupEditForm.MatchGroups" size="small"
                        :type="groupActiveIndex == index ? 'primary' : ''" @click="clickGroupItem(index)"
                        :icon="r.IsSuper == 1 ? 'el-icon-chaojihuiyuan' : ''">{{ r.GroupName }}</el-button>
                </div>
                <div style="margin-left: 10px;">
                    <el-button size="small" icon="el-icon-edit" type="primary"
                        @click="MatchGroupEditFormVisible = true">编辑分组</el-button>
                </div>
            </div>
            </el-row>
            <el-row style="margin-top: 10px;color: red;"
                v-if="!MatchGroupEditFormVisible && MatchGroupEditForm.MatchGroups.length > 0 && MatchGroupEditForm.MatchGroups[groupActiveIndex].GroupId != ''">
                <el-col :span="12">
                    限报年级：{{ MatchGroupEditForm.MatchGroups[groupActiveIndex].GradeCondition ?
                        MatchGroupEditForm.MatchGroups[groupActiveIndex].GradeCondition : '不限' }}
                </el-col>
            </el-row>
            <el-row style="margin-top: 10px;color: red;"
                v-if="!MatchGroupEditFormVisible && MatchGroupEditForm.MatchGroups.length > 0 && MatchGroupEditForm.MatchGroups[groupActiveIndex].GroupId != ''">
                <el-col :span="12">
                    限报年龄：<span v-if="MatchGroupEditForm.MatchGroups[groupActiveIndex].BirthdayStartTime == null &&
                        MatchGroupEditForm.MatchGroups[groupActiveIndex].BirthdayEndTime == null">不限</span>
                    <span v-if="MatchGroupEditForm.MatchGroups[groupActiveIndex].BirthdayStartTime != null &&
                        MatchGroupEditForm.MatchGroups[groupActiveIndex].BirthdayEndTime != null">
                        {{ MatchGroupEditForm.MatchGroups[groupActiveIndex].BirthdayStartTime.split(' ')[0] }}至{{
                            MatchGroupEditForm.MatchGroups[groupActiveIndex].BirthdayEndTime.split(' ')[0] }}出生</span>
                    <span v-if="MatchGroupEditForm.MatchGroups[groupActiveIndex].BirthdayStartTime
                        && !MatchGroupEditForm.MatchGroups[groupActiveIndex].BirthdayEndTime">{{
                        MatchGroupEditForm.MatchGroups[groupActiveIndex].BirthdayStartTime.split(' ')[0] }}后出生</span>
                    <span
                        v-if="!MatchGroupEditForm.MatchGroups[groupActiveIndex].BirthdayStartTime && MatchGroupEditForm.MatchGroups[groupActiveIndex].BirthdayEndTime">
                        {{MatchGroupEditForm.MatchGroups[groupActiveIndex].BirthdayEndTime.split(' ')[0] }}前出生</span>
                    <span style="margin:0 10px;" v-if="MatchGroupEditForm.MatchGroups[groupActiveIndex].MustHaveCertificate == 1">且运动员信息必须维护证件</span>
                </el-col>
            </el-row>
            
            <el-row style="margin-top: 10px;color: red;"
                v-if="!MatchGroupEditFormVisible && MatchGroupEditForm.MatchGroups.length > 0 && MatchGroupEditForm.MatchGroups[groupActiveIndex].GroupId != ''">
                <el-col :span="12">
                    队伍组成：领队{{ MatchGroupEditForm.MatchGroups[groupActiveIndex].TeamLeaderMaxNum > 0 ?
                        MatchGroupEditForm.MatchGroups[groupActiveIndex].TeamLeaderMaxNum + '人' : '不限' }}，
                    教练{{ MatchGroupEditForm.MatchGroups[groupActiveIndex].CoachMaxNum > 0 ?
                        MatchGroupEditForm.MatchGroups[groupActiveIndex].CoachMaxNum + '人' : '不限' }}，
                    医护人员{{ MatchGroupEditForm.MatchGroups[groupActiveIndex].MedicalMaxNum > 0 ?
                        MatchGroupEditForm.MatchGroups[groupActiveIndex].MedicalMaxNum + '人' : '不限' }}，
                    合计运动员{{ MatchGroupEditForm.MatchGroups[groupActiveIndex].AthleteMaxNum > 0 ?
                        MatchGroupEditForm.MatchGroups[groupActiveIndex].AthleteMaxNum + '人' : '不限' }}，
                    男运动员{{ MatchGroupEditForm.MatchGroups[groupActiveIndex].BoyAthleteMaxNum > 0 ?
                        MatchGroupEditForm.MatchGroups[groupActiveIndex].BoyAthleteMaxNum + '人' : '不限' }}，
                    女运动员{{ MatchGroupEditForm.MatchGroups[groupActiveIndex].GirlAthleteMaxNum > 0 ?
                        MatchGroupEditForm.MatchGroups[groupActiveIndex].GirlAthleteMaxNum + '人' : '不限' }}
                </el-col>
            </el-row>
            <el-row style="margin-top: 10px;color: red;"
                v-if="!MatchGroupEditFormVisible && MatchGroupEditForm.MatchGroups.length > 0 && MatchGroupEditForm.MatchGroups[groupActiveIndex].GroupId != ''">
                <el-col :span="12">
                    运动员限制：每人限报个人项目数{{
                        MatchGroupEditForm.MatchGroups[groupActiveIndex].EveryBodyRestrictReportPersonalProjectMaxNum > 0 ?
                            MatchGroupEditForm.MatchGroups[groupActiveIndex].EveryBodyRestrictReportPersonalProjectMaxNum + '个'
                            : '不限' }}，
                    每人限报团队项目数{{
                        MatchGroupEditForm.MatchGroups[groupActiveIndex].EveryBodyRestrictReportTeamProjectMaxNum > 0 ?
                            MatchGroupEditForm.MatchGroups[groupActiveIndex].EveryBodyRestrictReportTeamProjectMaxNum + '个' :
                            '不限' }}
                    每人可代表队伍数{{ MatchGroupEditForm.MatchGroups[groupActiveIndex].EveryBodyComposeTeamMaxNum > 0 ?
                        MatchGroupEditForm.MatchGroups[groupActiveIndex].EveryBodyComposeTeamMaxNum + '个' : '不限' }}
                </el-col>
            </el-row>

            <el-form label-width="120px" style="width: 1000px;" :model="MatchGroupEditForm" ref="MatchGroupEditForm"
                v-if="MatchGroupEditFormVisible">
                <el-card class="box-card" v-for="(r, index) in MatchGroupEditForm.MatchGroups"
                    style="margin-bottom: 10px;">
                    <el-form-item label="分组名称" :prop="'MatchGroups.' + index + '.GroupName'"
                        :rules="{ required: true, message: '分组名称不能为空', trigger: 'blur' }">
                        <el-row :gutter="10">
                            <el-col :span="14">
                                <el-input size="small" v-model="r.GroupName" placeholder="分组名称">
                                </el-input>
                            </el-col>
                            <el-col :span="1.5">
                                <el-checkbox v-model="r.IsSuperCheckBox"
                                    @change="onSuperCheckboxChange(r)">超级组</el-checkbox>
                            </el-col>
                            <el-col :span="1.5">
                                <el-button size="mini" circle icon="el-icon-delete" type="danger"
                                    @click="deleteGroupItem(index)"></el-button>
                            </el-col>
                            <el-col :span="1.5">
                                <el-button size="mini" circle icon="el-icon-caret-top" :disabled="index == 0"
                                    @click="orderMatchGroup(index, 'top')"></el-button>
                            </el-col>
                            <el-col :span="1">
                                <el-button size="mini" circle icon="el-icon-caret-bottom"
                                    :disabled="index >= MatchGroupEditForm.MatchGroups.length - 1"
                                    @click="orderMatchGroup(index, 'bottom')"></el-button>
                            </el-col>
                        </el-row>

                    </el-form-item>
                    <el-form-item label="限报年级">
                        <el-checkbox-group v-model="r.GradeConditionArr">
                            <el-checkbox v-for="grade in Grades" :label="grade"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="出生日期范围">
                        <el-date-picker size="small" v-model="r.BirthdayStartTime" type="date" value-format="yyyy-MM-dd"
                            placeholder="开始日期" style="width: 220px;"></el-date-picker>
                        <span> 至 </span>
                        <el-date-picker size="small" v-model="r.BirthdayEndTime" type="date" value-format="yyyy-MM-dd"
                            placeholder="结束日期" style="width: 220px;"></el-date-picker>
                        <span style="margin:0 10px;">运动员信息必须维护证件</span>
                        <el-radio-group v-model="r.MustHaveCertificate">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="队伍组成">
                        <el-input type="number" size="small" placeholder="领队" v-model="r.TeamLeaderMaxNum"
                            style="width: 220px;">
                            <template slot="prepend">领队</template>
                        </el-input>
                        <el-input type="number" size="small" placeholder="教练" v-model="r.CoachMaxNum"
                            style="width: 220px;">
                            <template slot="prepend">教练</template>
                        </el-input>
                        <el-input type="number" size="small" placeholder="医护人员" v-model="r.MedicalMaxNum"
                            style="width: 220px;">
                            <template slot="prepend">医护人员</template>
                        </el-input>
                        <el-input type="number" size="small" placeholder="运动员" v-model="r.AthleteMaxNum"
                            style="width: 220px;">
                            <template slot="prepend">运动员</template>
                        </el-input>
                        <el-input type="number" size="small" placeholder="男运动员" v-model="r.BoyAthleteMaxNum"
                            style="width: 220px;">
                            <template slot="prepend">男运动员</template>
                        </el-input>
                        <el-input type="number" size="small" placeholder="女运动员" v-model="r.GirlAthleteMaxNum"
                            style="width: 220px;">
                            <template slot="prepend">女运动员</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="运动员限制">
                        <el-input type="number" size="small" placeholder=""
                            v-model="r.EveryBodyRestrictReportPersonalProjectMaxNum" style="width: 250px;">
                            <template slot="prepend">每人限报个人项目数</template>
                        </el-input>
                        <el-input type="number" size="small" placeholder=""
                            v-model="r.EveryBodyRestrictReportTeamProjectMaxNum" style="width: 250px;">
                            <template slot="prepend">每人限报团队项目数</template>
                        </el-input>
                        <!-- <el-input type="number" size="small" placeholder="" v-model="r.EveryBodyComposeTeamMaxNum"
                            style="width: 250px;">
                            <template slot="prepend">每人可代表队伍数</template>
                        </el-input> -->
                    </el-form-item>
                </el-card>
                <div style="height: 30px;margin-bottom: 30px;text-align: right;">
                    <el-button type="" size="small" @click="showCommonMatchGroupsDialog">快捷选择</el-button>
                    <el-button type="" size="small" @click="addGroupItem('')">添加分组</el-button>
                    <el-button type="primary" size="small" @click="submitMatchGroupEdit">保存</el-button>
                    <el-button type="info" size="small" @click="MatchGroupEditFormVisible = false">取消</el-button>

                </div>

            </el-form>
            <div style="margin-top: 30px;" v-if="!MatchGroupEditFormVisible && MatchEditForm.MatchId != ''"">
            <el-button type=" primary" size="small" icon="el-icon-plus" @click="addMatchGroupProject">添加项目</el-button>
                <el-button type="primary" size="small" icon="el-icon-plus"
                    @click="showBatchEditProductDialog">批量添加项目</el-button>
                <el-table :data="MatchGroupProjectList" border style="width: 1255px;margin-top: 10px;" size="small"
                    :span-method="mergeSameRows">
                    <el-table-column prop="GenderRuleText" width="150" label="性别要求" />
                    <el-table-column width="400" label="项目名称">
                        <template v-slot="scope">
                            <span @click="editMatchGroupProject(scope.row)"
                                style="cursor: pointer;color: #3798ed ;text-decoration: underline">{{
                                    scope.row.ProjectName }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="ProjectTypeName" width="200" label="项目类型" />
                    <el-table-column prop="ProjectTypeName" width="150" label="必报项目">
                        <template v-slot="scope">
                            <span v-if="scope.row.IsMustSignUp == 1">是</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="AthleteNumberType" width="150" label="报名类型">
                        <template v-slot="scope">
                            <span v-if="scope.row.AthleteNumberType == 0">个人</span>
                            <span v-if="scope.row.AthleteNumberType == 1">团队</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="SignUpMaxPeopleNumText" width="150" label="报名人数" />
                    <!-- <el-table-column label="裁判人数" prop="RefereePeople" /> -->
                    <el-table-column label="操作" width="200">
                        <template slot-scope="scope">
                            <el-button type="primary" size="mini" icon="el-icon-edit"
                                @click="editMatchGroupProject(scope.row)">编辑</el-button>
                            <el-button type="danger" size="mini" icon="el-icon-delete"
                                @click="deleteMatchGroupProject(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>

            </div>
            <el-dialog title="编辑项目" :visible.sync="EditProjectDialogVisible" :close-on-press-escape="false"
                :show-close="false" width="50%" :before-close="handleEditDialogClose">
                <div style=" width: 80%;margin: 0 auto;">

                    <el-divider>项目信息</el-divider>
                    <el-form label-width="200px" :model="MatchProjectEditForm" :rules="MatchProjectEditFormRules"
                        ref="MatchProjectEditFormRef">
                        <el-form-item label="项目名称" prop="ProjectName">
                            <el-input size="small" v-model="MatchProjectEditForm.ProjectName" placeholder="项目名称" />
                        </el-form-item>
                        <el-form-item label="组别" prop="GroupId">
                            <el-select size="small" v-model="MatchProjectEditForm.GroupId" placeholder="组别">
                                <el-option v-for="item in MatchGroupEditForm.MatchGroups" :key="item.GroupId"
                                    :label="((item.IsSuper == 1 ? '【超级组】' : '【普通组】') + item.GroupName)"
                                    :value="item.GroupId">
                                    {{ (item.IsSuper == 1 ? "【超级组】" : "【普通组】") + item.GroupName }}
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="项目类型" prop="ProjectTypeId">
                            <el-select size="small" v-model="MatchProjectEditForm.ProjectTypeId" placeholder="项目类型">
                                <el-option v-for="item in ProjectTypeList" :key="item.ProjectTypeId"
                                    :label="item.ProjectTypeName" :value="item.ProjectTypeId" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="必报项目">
                            <el-radio v-model="MatchProjectEditForm.IsMustSignUp" :label="0">否</el-radio>
                            <el-radio v-model="MatchProjectEditForm.IsMustSignUp" :label="1">是</el-radio>
                        </el-form-item>
                        <el-form-item label="性别规则" prop="GenderRule">
                            <el-select size="small" :disabled="MatchProjectEditForm.ProjectId != ''"
                                v-model="MatchProjectEditForm.GenderRule" placeholder="性别规则">
                                <el-option v-for="item in GenderRuleList" :key="item.value" :label="item.label"
                                    :value="item.value" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="报名形式" prop="SignUpLimitType">
                            <el-radio v-model="MatchProjectEditForm.SignUpLimitType" :label="1">人</el-radio>
                            <el-radio v-model="MatchProjectEditForm.SignUpLimitType" :label="0">队</el-radio>
                        </el-form-item>

                        <el-form-item :label="MatchProjectEditForm.SignUpLimitType == 0 ? '限报队' : '限报人数'"
                            prop="SignUpLimitNum">
                            <el-input-number size="small" v-model="MatchProjectEditForm.SignUpLimitNum"
                                controls-position="right" :min="1" :max="100"></el-input-number>
                        </el-form-item>

                        <el-form-item label="男子人数" v-if="MatchProjectEditForm.SignUpLimitType == 0">
                            <el-row>

                                <el-input-number size="small" v-model="MatchProjectEditForm.SignUpBoyMinNum"
                                    controls-position="right" :min="0" :max="100"
                                    :disabled="MatchProjectEditForm.GenderRule == 1"></el-input-number>

                                <span style="margin: 0 10px;">到</span>


                                <el-input-number size="small" v-model="MatchProjectEditForm.SignUpBoyMaxNum"
                                    controls-position="right" :min="1" :max="100"
                                    :disabled="MatchProjectEditForm.GenderRule == 1"></el-input-number>
                            </el-row>
                        </el-form-item>
                        <el-form-item label="女子人数" v-if="MatchProjectEditForm.SignUpLimitType == 0">
                            <el-row>

                                <el-input-number size="small" v-model="MatchProjectEditForm.SignUpGirlMinNum"
                                    controls-position="right" :min="0" :max="100"
                                    :disabled="MatchProjectEditForm.GenderRule == 0"></el-input-number>
                                <span style="margin: 0 10px;">到</span>

                                <el-input-number size="small" v-model="MatchProjectEditForm.SignUpGirlMaxNum"
                                    controls-position="right" :min="1" :max="100"
                                    :disabled="MatchProjectEditForm.GenderRule == 0"></el-input-number>
                            </el-row>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button size="small" @click="handleEditDialogClose">取 消</el-button>
                    <el-button size="small" type="primary" @click="submitMatchProjectEdit">确 定</el-button>
                </span>
            </el-dialog>
            <el-dialog title="批量新增项目" :visible.sync="BatchEditProjectDialogVisible" :close-on-press-escape="false"
                :show-close="false" width="70%" :before-close="handleEditDialogClose">
                <div style=" width: 80%;margin: 0 auto;">
                    <el-form label-width="50px">
                        <el-form-item label="分组">
                            <el-checkbox-group v-model="CheckGroupList">
                                <el-checkbox v-for="g in MatchGroupEditForm.MatchGroups" :key="g.GroupId"
                                    :label="g.GroupId">
                                    {{ g.GroupName }}
                                </el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                        <el-form-item label="性别">
                            <el-checkbox-group v-model="CheckGenderRuleList">
                                <el-checkbox v-for="g in GenderRuleList" :key="g.value" :label="g.value">
                                    {{ g.label }}
                                </el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>


                        <el-form-item label="项目" v-if="BatchEditProjectStep == 1">
                            <div v-for="type in CommonMatchProjectTypes">
                                <p>{{ type.ProjectTypeName }}</p>
                                <el-checkbox-group v-model="CheckProjectList">
                                    <el-checkbox style="width: 180px;" v-for="pro in type.CommonProjects"
                                        :key="pro.ProjectId" :label="pro.ProjectId">
                                        {{ pro.ProjectName }}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </div>

                        </el-form-item>



                    </el-form>
                    <el-table :data="MatchProjectEditForms" v-if="BatchEditProjectStep == 2">
                        <el-table-column label="项目名">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.ProjectName" size="small"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="项目类型">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.ProjectTypeId" size="small">
                                    <el-option v-for="item in ProjectTypeList" :label="item.ProjectTypeName"
                                        :value="item.ProjectTypeId" />
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column label="是否必报" prop="">
                            <template slot-scope="scope">
                                <el-radio v-model="scope.row.IsMustSignUp" :label="1">是</el-radio>
                                <el-radio v-model="scope.row.IsMustSignUp" :label="0">否</el-radio>
                            </template>
                        </el-table-column>
                        <el-table-column label="限报人数/队数" prop="">
                            <template slot-scope="scope">
                                <el-input-number size="small" v-model="scope.row.SignUpLimitNum"
                                    controls-position="right" :min="1" :max="100"></el-input-number>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button size="small" type="primary" v-if="BatchEditProjectStep == 2"
                        @click="BatchEditProjectStep = 1">上一步</el-button>
                    <el-button size="small" type="primary" v-if="BatchEditProjectStep == 1"
                        @click="nextBatchMatchProject">下一步</el-button>
                    <el-button size="small" type="primary" v-if="BatchEditProjectStep == 2"
                        @click="submitBatchMatchProjectEdit">提
                        交</el-button>
                    <el-button size="small" @click="BatchEditProjectDialogVisible = false">取 消</el-button>
                </span>
            </el-dialog>

            <el-dialog title="上传文件" :visible.sync="uploadDialogVisible" :close-on-press-escape="false"
                :show-close="false" width="50%">

                <div style="text-align: center;">
                    <el-upload class="upload-demo" drag multiple :http-request="customRequest" action=""
                        :file-list="file_list" accept=".doc,.docx,.ppt,.pdf,.zip,.rar">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">只能上传doc/docx/ppt/pdf/zip/rar文件</div>
                    </el-upload>
                </div>

                <span slot="footer" class="dialog-footer">
                    <el-button size="small" @click="uploadDialogVisible = false">关 闭</el-button>
                </span>
            </el-dialog>

            <el-dialog title="选择常用分组" :visible.sync="commonMatchGroupsDialogVisible" :close-on-press-escape="false"
                :show-close="false" width="50%">
                <div style="width: 80%;margin: 0 auto;" v-if="CommonMatchGroupsVisible">
                    <div v-for="(item, index) in CommonMatchGroups">
                        <h1>{{ item.GroupName }}</h1>
                        <!-- <el-checkbox v-for="(subItem) in item.SubItems" :label="subItem.GroupName"></el-checkbox> -->
                        <el-tag style="margin-bottom: 5px;" v-for="(subItem, subIndex) in item.SubItems"
                            :type="subItem.checked ? '' : 'info'" @click="checkedGroupItem(index, subIndex)">{{
                                subItem.GroupName
                            }}</el-tag>
                    </div>

                </div>

                <span slot="footer" class="dialog-footer">

                    <el-button type="primary" size="small" @click="confirmChooseGroups">确 认</el-button>
                    <el-button type="" size="small" @click="commonMatchGroupsDialogVisible = false">关 闭</el-button>
                </span>
            </el-dialog>
    </div>
</template>

<script>
import MatchService from '@/request-server/request-services/match-services.js';
import SystemService from '@/request-server/request-services/system-services.js';

import Common from '@/utils/utils-common.js';
import Url from '../../../request-server/request-url';
export default {
    data() {
        return {
            routeMatchId: '',
            allLoading: false,
            size: 'default',
            fileRootPath: Url.getDownloadBaseUrl() + 'uploadfiles/',
            file_list: [],
            uploadDialogVisible: false,
            commonMatchGroupsDialogVisible: false,
            groupActiveIndex: 0,
            MatchEditForm: {
                MatchId: '',
                MatchName: '',
                MatchSimpleName: '',
                MatchSignUpTimes: '',
                MatchTime: '',
                StartTime: '',
                EndTime: '',
                LimitSignUpTeamNum: 0,
                LimitSignUpProjectNum: 0,
                EveryBodyComposeTeamMaxNum: 0,
                MatchAddress: '',
                MatchIntroduction: '',
                MatchProjects: [],//项目配置,
                Files: [],
                AutoAudit: 0,
                ScoreLargeScreenBackGroundImageFile: null,
                RankLargeScreenBackGroundImageFile: null,
                ScoreLargeScreenBackGroundImageFilePath: '',
                RankLargeScreenBackGroundImageFilePath: ''
            },
            MatchGroupEditForm: {
                MatchGroups: [{
                    MatchId: '',
                    GroupId: '',
                    GroupName: '',
                    GroupSort: 0,
                    IsSuperCheckBox: false,
                    Projects: [],
                    GradeCondition: '',
                    BirthdayStartTime: null,
                    BirthdayEndTime: null,
                    MustHaveCertificate: 0
                }]
            },
            MatchProjectEditForm: {
                ProjectId: '',
                MatchId: '',
                GroupId: '',
                ProjectName: '',
                ProjectTypeId: '',
                AthleteNumberType: 0,
                GenderRule: 0,
                VenueCount: 1,
                IsMustSignUp: 0,
                SignUpLimitType: 1,
                SignUpLimitNum: 1,
                SignUpBoyMinNum: 1,
                SignUpBoyMaxNum: 4,
                SignUpGirlMinNum: 1,
                SignUpGirlMaxNum: 4,
                RefereePeopleConfig: []
            },
            MatchEditFormRules: {
                MatchName: [{ required: true, message: '请输入赛事名称', trigger: 'blur' }],
                MatchSimpleName: [{ required: true, message: '请输入赛事简称', trigger: 'blur' }],
                MatchTime: [{ required: true, message: '请输入比赛时间', trigger: 'blur' }],
                MatchSignUpTimes: [{ required: true, message: '请输入报名时间', trigger: 'blur' }],
                LimitSignUpTeamNum: [{ required: true, message: '请输入限报队数', trigger: 'blur' }],
                LimitSignUpProjectNum: [{ required: true, message: '请输入限报项目数', trigger: 'blur' }],
                EveryBodyComposeTeamMaxNum: [{ required: true, message: '请输入每人限报队伍数', trigger: 'blur' }],
                MatchAddress: [{ required: true, message: '请输入赛事地点', trigger: 'blur' }],
                MatchIntroduction: [{ required: true, message: '请输入赛事介绍', trigger: 'blur' }],
            },
            MatchProjectEditFormRules: {
                ProjectName: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
                GroupId: [{ required: true, message: '请选择组别', trigger: 'blur' }],
                ProjectTypeId: [{ required: true, message: '请选择项目类型', trigger: 'blur' }],
                SignUpLimitNum: [{ required: true, message: '请输入限报数', trigger: 'blur' }],
            },
            MatchGroupList: [],
            MatchGroupProjectList: [],
            ProjectTypeList: [],
            GenderRuleList: [{ label: '男子', value: 0 }, { label: '女子', value: 1 }, { label: '男女混合', value: 2 }],
            MatchGroupEditFormVisible: false,
            EditProjectDialogVisible: false,
            AllRefereeTypeList: [],
            CommonMatchGroups: [],
            CheckCommonMatchGroups: [],
            CommonMatchGroupsVisible: true,
            BatchEditProjectDialogVisible: false,
            CheckGroupList: [],
            CheckGenderRuleList: [],
            CheckProjectList: [],
            CommonMatchProjectTypes: [],
            BatchEditProjectStep: 1,
            MatchProjectEditForms: [],
            Grades: ['一年级', '二年级', '三年级', '四年级', '五年级', '六年级', '初一', '初二', '初三', '高一', '高二', '高三', '大一', '大二', '大三', '大四', '研究生', '其他']
        }
    },
    watch: {
        '$route'(to, from) {
            this.initMatchDetail();
            this.selectProjectTypeList();
            this.getAllRefereeType();
            this.initCommonMatchGroups();
            this.initCommonMatchProjects();
        }
    },
    created() {
        this.initMatchDetail();
        this.selectProjectTypeList();
        this.getAllRefereeType();
        this.initCommonMatchGroups();
        this.initCommonMatchProjects();
    },
    methods: {
        initMatchDetail() {
            let id = this.$route.params.id;
            if (id) {
                this.routeMatchId = id;
                this.getMatchDetail(id);
            }
        },
        initCommonMatchGroups() {
            SystemService.getCommonMatchGroups().then(res => {
                if (res.code == 0) {
                    this.CommonMatchGroups = res.data;
                }
            })
        },
        initCommonMatchProjects() {
            SystemService.getCommonMatchProjects().then(res => {
                if (res.code == 0) {
                    this.CommonMatchProjectTypes = res.data;
                }
            })
        },
        showCommonMatchGroupsDialog() {
            this.CommonMatchGroups.forEach(element => {
                element.SubItems.forEach(item => {
                    item['checked'] = false;
                });
            });
            this.commonMatchGroupsDialogVisible = true;
        },
        checkedGroupItem(pIndex, index) {
            this.CommonMatchGroups[pIndex].SubItems[index]['checked'] = !this.CommonMatchGroups[pIndex].SubItems[index]['checked'];
            this.CommonMatchGroupsVisible = false;
            this.CommonMatchGroupsVisible = true;
        },
        confirmChooseGroups() {

            this.CommonMatchGroups.forEach(element => {
                element.SubItems.forEach(item => {
                    if (item.checked) {
                        this.addGroupItem(item.GroupName);
                    }
                });
            });
            this.commonMatchGroupsDialogVisible = false;
        },
        getMatchDetail(id) {
            this.allLoading = true;
            MatchService.getMatchDetail({ matchId: id }).then(res => {
                this.allLoading = false;
                if (res.code == 0) {

                    if (res.data == null) {
                        this.$message.warning('赛事不存在或已被删除');
                        setTimeout(() => {
                            this.$router.push('/mainpage/match-manage');
                        }, 1500);
                    } else {
                        this.MatchEditForm = res.data;
                        //this.MatchEditForm.MatchSignUpTimes = [];
                        this.MatchEditForm.Files = this.MatchEditForm.Files == null ? [] : this.MatchEditForm.Files;
                        this.$set(this.MatchEditForm, 'MatchSignUpTimes', [this.MatchEditForm.SignUpStartTime, this.MatchEditForm.SignUpEndTime])
                        this.$set(this.MatchEditForm, 'MatchTime', [this.MatchEditForm.StartTime, this.MatchEditForm.EndTime])

                        this.MatchGroupEditForm.MatchId = this.MatchEditForm.MatchId;
                        this.MatchGroupEditForm.MatchGroups = res.data.MatchGroups;

                        this.MatchGroupEditForm.MatchGroups.forEach(item => {
                            // Properly set the checkbox value
                            this.$set(item, 'IsSuperCheckBox', item.IsSuper == 1 ? true : false);
                            item.Projects.forEach(project => {
                                project.SignUpMaxPeopleNumText = project.SignUpLimitNum == 0 ? '不限' : '限报' + project.SignUpLimitNum + (project.SignUpLimitType == 1 ? '人' : '队');
                            });
                        });
                        if (this.MatchGroupEditForm.MatchGroups && this.MatchGroupEditForm.MatchGroups.length > 0) {
                            this.groupActiveIndex = this.groupActiveIndex == -1 ? 0 : this.groupActiveIndex;
                            this.clickGroupItem(this.groupActiveIndex);
                        }
                    }

                }
            });
        },
        selectProjectTypeList() {
            MatchService.selectProjectTypeList().then(res => {
                if (res.code == 0) {
                    this.ProjectTypeList = res.data;
                }
            })
        },
        getAllRefereeType() {
            MatchService.selectProjectRefereePeopleConfig().then(res => {
                if (res.code == 0) {
                    this.AllRefereeTypeList = res.data;
                }
            })
        },
        addGroupItem(groupName = '') {
            this.MatchGroupEditForm.MatchGroups.push({
                MatchId: this.MatchEditForm.MatchId,
                GroupId: '',
                GroupName: groupName,
                GroupSort: 0,
                TeamLeaderMaxNum: -1,
                CoachMaxNum: -1,
                MedicalMaxNum: -1,
                AthleteMaxNum: -1,
                BoyAthleteMaxNum: -1,
                GirlAthleteMaxNum: -1,
                EveryBodyRestrictReportPersonalProjectMaxNum: -1,
                EveryBodyRestrictReportTeamProjectMaxNum: -1,
                EveryBodyComposeTeamMaxNum: -1,
                GradeCondition: '',
                GradeConditionArr: [],
                IsSuper: 0,
                IsSuperCheckBox: false,
                MustHaveCertificate: 0,
                BirthdayStartTime: null,
                BirthdayEndTime: null,
            });
        },
        deleteGroupItem(index) {
            this.MatchGroupEditForm.MatchGroups.splice(index, 1);
        },
        orderMatchGroup(index, type) {

            let temp = this.MatchGroupEditForm.MatchGroups[index];
            if (type == 'top') {
                this.MatchGroupEditForm.MatchGroups[index] = this.MatchGroupEditForm.MatchGroups[index - 1];
                this.MatchGroupEditForm.MatchGroups[index - 1] = temp;

            } else {
                this.MatchGroupEditForm.MatchGroups[index] = this.MatchGroupEditForm.MatchGroups[index + 1];
                this.MatchGroupEditForm.MatchGroups[index + 1] = temp;
            }
            this.MatchGroupEditFormVisible = false;
            this.MatchGroupEditFormVisible = true;
        },
        submitMatchGroupEdit() {
            this.$refs.MatchGroupEditForm.validate((valid) => {
                if (valid) {
                    this.allLoading = true;
                    let isAllValid = true;

                    this.MatchGroupEditForm.MatchGroups.forEach(item => {
                        item.TeamLeaderMaxNum = item.TeamLeaderMaxNum ? item.TeamLeaderMaxNum : -1;
                        item.CoachMaxNum = item.CoachMaxNum ? item.CoachMaxNum : -1;
                        item.MedicalMaxNum = item.MedicalMaxNum ? item.MedicalMaxNum : -1;
                        item.AthleteMaxNum = item.AthleteMaxNum ? item.AthleteMaxNum : -1;
                        item.BoyAthleteMaxNum = item.BoyAthleteMaxNum ? item.BoyAthleteMaxNum : -1;
                        item.GirlAthleteMaxNum = item.GirlAthleteMaxNum ? item.GirlAthleteMaxNum : -1;
                        item.EveryBodyRestrictReportPersonalProjectMaxNum = item.EveryBodyRestrictReportPersonalProjectMaxNum ? item.EveryBodyRestrictReportPersonalProjectMaxNum : -1;
                        item.EveryBodyRestrictReportTeamProjectMaxNum = item.EveryBodyRestrictReportTeamProjectMaxNum ? item.EveryBodyRestrictReportTeamProjectMaxNum : -1;
                        item.EveryBodyComposeTeamMaxNum = item.EveryBodyComposeTeamMaxNum ? item.EveryBodyComposeTeamMaxNum : -1;
                        console.log(item.AthleteMaxNum != -1 && item.BoyAthleteMaxNum != -1 && item.GirlAthleteMaxNum != -1);

                        if (item.AthleteMaxNum != -1 && item.BoyAthleteMaxNum != -1 && item.GirlAthleteMaxNum != -1
                            && parseInt(item.AthleteMaxNum) != parseInt(item.BoyAthleteMaxNum) + parseInt(item.GirlAthleteMaxNum)
                        ) {
                            isAllValid = false;
                            this.$message.warning(item.GroupName + '运动员人数与男运动员人数与女运动员人数和不一致');
                            return;
                        }
                    });
                    if (!isAllValid) {
                        return;
                    }

                    // Make sure to update IsSuper based on IsSuperCheckBox before saving
                    this.MatchGroupEditForm.MatchGroups.forEach(item => {
                        item.IsSuper = item.IsSuperCheckBox ? 1 : 0;
                    });

                    this.MatchGroupEditForm.MatchGroups.forEach(item => {
                        item.GradeCondition = item.GradeConditionArr.length > 0 ? item.GradeConditionArr.join(',') : '';
                    });

                    MatchService.editMatchGroup(this.MatchGroupEditForm.MatchGroups).then(res => {
                        this.allLoading = false;
                        if (res.code == 0) {
                            this.$message.success('编辑成功');
                            this.MatchGroupEditFormVisible = false;
                            this.getMatchDetail(this.MatchEditForm.MatchId);
                        }
                    });
                }
            });
        },
        submitMatchEdit() {
            this.$refs.MatchEditFormRef.validate((valid) => {
                if (valid) {
                    this.allLoading = true;
                    this.MatchEditForm.StartTime = Common.formatDate(this.MatchEditForm.MatchTime[0], 'YYYY-MM-DDTHH:mm:ss');
                    this.MatchEditForm.EndTime = Common.formatDate(this.MatchEditForm.MatchTime[1], 'YYYY-MM-DDTHH:mm:ss');
                    this.MatchEditForm.SignUpStartTime = Common.formatDate(this.MatchEditForm.MatchSignUpTimes[0], 'YYYY-MM-DDTHH:mm:ss');
                    this.MatchEditForm.SignUpEndTime = Common.formatDate(this.MatchEditForm.MatchSignUpTimes[1], 'YYYY-MM-DDTHH:mm:ss');

                    MatchService.editMatch(this.MatchEditForm).then(res => {
                        this.allLoading = false;
                        if (res.code == 0) {
                            this.$message.success('编辑成功');
                            this.MatchEditForm.MatchId = res.data;
                            //跳转页面
                            if (this.routeMatchId == '') {
                                setTimeout(() => {
                                    this.$router.push('/mainpage/match-edit/' + res.data);
                                }, 1500);
                            }
                        }
                    })
                }
            });
        },
        clickGroupItem(index) {
            this.groupActiveIndex = index;
            this.MatchGroupProjectList = this.MatchGroupEditForm.MatchGroups[this.groupActiveIndex].Projects;
            if (this.MatchGroupProjectList && this.MatchGroupProjectList.length > 1) {
                this.MatchGroupProjectList = this.MatchGroupProjectList.sort((a, b) => a.GenderRule - b.GenderRule)
            }

        },
        mergeSameRows({ row, rowIndex, columnIndex }) {
            if (this.MatchGroupProjectList && this.MatchGroupProjectList.length <= 1) {
                return { rowspan: 1, colspan: 1 }
            }

            if (columnIndex == 0) {
                if (rowIndex > 0 && rowIndex != this.MatchGroupProjectList.length - 1) {
                    if (this.MatchGroupProjectList[rowIndex - 1].GenderRule == row.GenderRule) {
                        //隐藏单元格
                        return { rowspan: 0, colspan: 0 }
                    }
                }
                else if (rowIndex == this.MatchGroupProjectList.length - 1 && row.GenderRule != this.MatchGroupProjectList[rowIndex - 1].GenderRule) {
                    return { rowspan: 1, colspan: 1 }
                } else if (rowIndex == this.MatchGroupProjectList.length - 1 && row.GenderRule == this.MatchGroupProjectList[rowIndex - 1].GenderRule) {
                    return { rowspan: 0, colspan: 0 }
                }

                let index = rowIndex;
                let rowspan = 1;
                let isStop = false;
                while (index < this.MatchGroupProjectList.length - 1 && !isStop) {
                    if (this.MatchGroupProjectList[index + 1].GenderRule != row.GenderRule) {
                        isStop = true;
                    } else {
                        index++;
                        rowspan++;
                    }

                }

                return { rowspan: rowspan, colspan: 1 }

            }
            //保持原样
            return { rowspan: 1, colspan: 1 }
        },
        addMatchGroupProject() {

            this.MatchProjectEditForm = {
                ProjectId: '',
                MatchId: '',
                GroupId: '',
                ProjectName: '',
                ProjectTypeId: '',
                GenderRule: 0,
                VenueCount: 0,
                AthleteNumberType: 0,
                SignUpLimitType: 1,
                SignUpLimitNum: 1,
                SignUpBoyMinNum: 1,
                SignUpBoyMaxNum: 4,
                SignUpGirlMinNum: 1,
                SignUpGirlMaxNum: 4,
                RefereePeopleConfig: []
            },

                this.MatchProjectEditForm.RefereePeopleConfig = this.AllRefereeTypeList;
            this.MatchProjectEditForm.GroupId = this.MatchGroupEditForm.MatchGroups[this.groupActiveIndex].GroupId;
            this.EditProjectDialogVisible = true;
        },
        editMatchGroupProject(row) {
            this.MatchProjectEditForm = { ...row };
            this.EditProjectDialogVisible = true;
        },
        handleEditDialogClose() {
            this.EditProjectDialogVisible = false;
        },
        deleteMatchGroupProject(row) {
            //删除确认提示
            this.$confirm('确定删除该项目吗？').then(() => {
                MatchService.deleteMatchProject({ projectId: row.ProjectId }).then(res => {
                    if (res.code == 0) {
                        this.$message.success('删除成功');
                        this.getMatchDetail(this.MatchEditForm.MatchId);
                    }
                });
            });
        },
        submitMatchProjectEdit() {
            this.$refs.MatchProjectEditFormRef.validate((valid) => {
                if (valid) {
                    this.allLoading = true;
                    this.MatchProjectEditForm.MatchId = this.MatchEditForm.MatchId;
                    this.MatchProjectEditForm.StartTime = Common.formatDate(this.MatchEditForm.MatchTime[0], 'YYYY-MM-DDTHH:mm:ss');
                    this.MatchProjectEditForm.EndTime = Common.formatDate(this.MatchEditForm.MatchTime[1], 'YYYY-MM-DDTHH:mm:ss');
                    MatchService.editMatchProject(this.MatchProjectEditForm).then(res => {
                        this.allLoading = false;
                        if (res.code == 0) {
                            this.$message.success('编辑成功');
                            this.EditProjectDialogVisible = false;
                            this.getMatchDetail(this.MatchEditForm.MatchId);
                        }
                    });
                }
            });
        },
        customRequest(file) {
            const formData = new FormData();
            formData.append('files', file.file);
            formData.append('desc', 'match-files');
            formData.append('type', 'match-files');
            if (this.MatchEditForm.Files == null) this.MatchEditForm.Files = [];
            SystemService.uploadFiles(formData).then(res => {
                if (res.code == 0) {
                    this.file_list = [];
                    this.MatchEditForm.Files = [...this.MatchEditForm.Files, ...res.data]
                    this.uploadDialogVisible = false;
                }
            })

        },
        customRequestBgImage(file, type) {
            console.log(type)
            const formData = new FormData();
            formData.append('files', file.file);
            formData.append('desc', 'match-material-files');
            formData.append('type', 'match-material-files');
            SystemService.uploadFiles(formData).then(res => {
                if (res.code == 0) {
                    if (type == 'score') {
                        this.MatchEditForm.ScoreLargeScreenBackGroundImageFile = res.data[0].FileId;
                        this.MatchEditForm.ScoreLargeScreenBackGroundImageFilePath = '/match-material-files/' + res.data[0].FileId + res.data[0].FileSuffix;
                    } else if (type == 'rank') {
                        this.MatchEditForm.RankLargeScreenBackGroundImageFile = res.data[0].FileId;
                        this.MatchEditForm.RankLargeScreenBackGroundImageFilePath = '/match-material-files/' + res.data[0].FileId + res.data[0].FileSuffix;
                    }
                }
                console.log(this.MatchEditForm);
            })
        },


        handleRemoveBackGroundImage(type) {
            if (type == 'score') {
                this.MatchEditForm.ScoreLargeScreenBackGroundImageFile = '';
                this.MatchEditForm.ScoreLargeScreenBackGroundImageFilePath = '';
            } else if (type == 'rank') {
                this.MatchEditForm.RankLargeScreenBackGroundImageFile = '';
                this.MatchEditForm.RankLargeScreenBackGroundImageFilePath = '';
            }
        },

        showBatchEditProductDialog() {
            this.BatchEditProjectStep = 1;
            this.CheckGroupList = [];
            this.CheckGenderRuleList = [];
            this.CheckProjectList = [];
            this.BatchEditProjectDialogVisible = true;

        },
        submitBatchMatchProjectEdit() {

            //检查数据
            if (this.CheckGroupList.length == 0) {
                this.$message.error('请选择分组');
                return;
            }

            //检查数据
            if (this.CheckGenderRuleList.length == 0) {
                this.$message.error('请选择性别');
                return;
            }


            if (this.MatchProjectEditForms.length == 0) {
                this.$message.error('项目列表不能为空');
                return;
            }

            let data = {
                GroupIds: this.CheckGroupList,
                GenderRules: this.CheckGenderRuleList,
                Projects: this.MatchProjectEditForms
            }


            MatchService.batchEditMatchProject(data).then(res => {
                if (res.code == 0) {
                    this.$message.success(res.data);
                    this.BatchEditProjectDialogVisible = false;
                    this.getMatchDetail(this.MatchEditForm.MatchId);
                }
            })



        },
        nextBatchMatchProject() {
            //检查数据
            if (this.CheckProjectList.length == 0) {
                this.$message.error('请选择项目');
                return;
            }
            this.MatchProjectEditForms = [];
            this.CheckProjectList.forEach(proId => {

                this.CommonMatchProjectTypes.forEach(t => {
                    if (t.CommonProjects.length > 0) {
                        let project = t.CommonProjects.find(a => a.ProjectId == proId);
                        if (project) {
                            this.MatchProjectEditForms.push({
                                MatchId: this.MatchEditForm.MatchId,
                                ProjectName: project.ProjectName,
                                ProjectTypeId: project.ProjectTypeId,
                                GenderRule: 0,
                                VenueCount: 1,
                                IsMustSignUp: 0,
                                SignUpLimitType: 1,
                                SignUpLimitNum: 1,
                                SignUpBoyMinNum: 1,
                                SignUpBoyMaxNum: 4,
                                SignUpGirlMinNum: 1,
                                SignUpGirlMaxNum: 4,
                                ProjectStartTime: this.MatchEditForm.StartTime,
                                ProjectEndTime: this.MatchEditForm.EndTime,
                            })
                        }


                    }
                })

            });
            this.BatchEditProjectStep = 2;
        },
        onSuperCheckboxChange(row) {
            // Update the IsSuper property to match the checkbox state
            row.IsSuper = row.IsSuperCheckBox ? 1 : 0;
        }
    }
}
</script>

<style lang="scss" scoped>
.el-tag {
    margin-right: 10px;
    min-width: 80px;
    text-align: center;
    cursor: pointer;
}

.file-item {
    display: flex;
    padding: 0 10px;
}

.file-item:hover {
    background-color: #ebebeb;
}

.file-item .del {
    cursor: pointer;
    color: red;
}

img {
    width: 120px;
    border-radius: 4px;
    object-fit: cover;

}

i {
    cursor: pointer;
}

i:hover {
    color: red;
}
</style>
